import { render, staticRenderFns } from "./ManageBanners_2.vue?vue&type=template&id=2ea1a69d&"
import script from "./ManageBanners_2.vue?vue&type=script&lang=js&"
export * from "./ManageBanners_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports